import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';

import {
  areAllInstructorsSameSelector,
  selectedInstructorRequiredAcademyTopicsSelector,
  setInstructorForAll,
} from 'features/classCreation';

/**
 *
 * @param {String} instructorType - One of
 * ['primaryInstructor', 'secondaryInstructor']
 */
function useSameInstructorToggle(instructorType) {
  const dispatch = useDispatch();
  const areAllSame = useSelector((state) =>
    areAllInstructorsSameSelector(state, instructorType)
  );
  const academyTopics = useSelector(
    selectedInstructorRequiredAcademyTopicsSelector
  );

  const handleToggle = useCallback(() => {
    if (academyTopics.length === 0) {
      cogoToast.error('No lecture has been selected to perform this action!');
      return;
    }

    const selectedInstructors = Object.values(
      academyTopics.reduce((result, academyTopic) => {
        const instructor = academyTopic[instructorType];
        if (instructor && !result[instructor.value]) {
          result[instructor.value] = instructor;
        }
        return result;
      }, {})
    );

    if (selectedInstructors.length === 0) {
      cogoToast.error('Select instructor for atleast 1 lecture!');
    } else if (selectedInstructors.length > 1) {
      cogoToast.error(
        'More than 1 instructor selected across multiple lectures!'
      );
    } else {
      dispatch(
        setInstructorForAll({
          instructorType,
          instructor: selectedInstructors[0],
        })
      );
    }
  }, [academyTopics, dispatch, instructorType]);

  return { onToggle: handleToggle, areAllInstructorsSame: areAllSame };
}

export default useSameInstructorToggle;
